import { DataList } from "@/components";
import type { Moneda } from "@/lib/api";
import { formatMoneda } from "@/lib/format";
import type { ParteVistaPrevia } from "@/lib/grupos";

/** Cómo se reparte el aporte del grupo entre sus miembros, mientras se escribe el monto (Aportes y Grupos). */
export function VistaPreviaGrupo({ partes, moneda }: { partes: ParteVistaPrevia[] | null; moneda: Moneda }) {
  if (!partes) return null;
  const columnas = [
    {
      clave: "nombre",
      titulo: "Fiduciante",
      render: (p: ParteVistaPrevia) => p.nombre,
    },
    {
      clave: "pct",
      titulo: "%",
      render: (p: ParteVistaPrevia) => p.porcentaje,
    },
    {
      clave: "monto",
      titulo: "Le toca",
      render: (p: ParteVistaPrevia) => formatMoneda(p.monto, moneda),
    },
  ];
  return <DataList etiqueta="Reparto del aporte" columnas={columnas} filas={partes} claveFila={(p) => p.fiduciante_id} />;
}
